<template>
  <div>
    <Pane :title="'重新提交物资采购记录'"/>

    <div class="container">
      <a-spin :spinning="loading">
        <PurchaseMaterialsForm
            v-if="editData"
            ref="form"
            :editData="editData"
            @submit="handleSubmit"
            @close="handleClose"
        />
      </a-spin>
    </div>
  </div>
</template>

<script>
import PurchaseMaterialsForm from "./form.vue";
import {fetchOfficeDetail, resubmitOfficeApply} from "@/api/oa/purchaseMaterials";

export default {
  components: {PurchaseMaterialsForm},

  data() {
    return {
      loading: false,
      editData: null,
    };
  },

  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loadDetail(id);
    }
  },

  methods: {
    loadDetail(id) {
      this.loading = true;
      fetchOfficeDetail(id)
          .then((res) => {
            this.editData = res;
          })
          .finally(() => {
            this.loading = false;
          });
    },

    handleSubmit(payload) {
      payload.id = this.$route.query.id;
      this.$refs.form.setLoading(true);
      resubmitOfficeApply(payload)
          .then(() => {
            this.$message.success("提交成功");
            this.$close(this.$route.path);
          })
          .finally(() => {
            this.$refs.form.setLoading(false);
          });
    },

    handleClose() {
      this.$close(this.$route.path);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}
</style>